(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2146],{

/***/ 43068:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signature/pdf-tools",
      function () {
        return __webpack_require__(72023);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 59183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_SignatureRegister__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71605);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _Buttons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46687);
/* harmony import */ var _components_AppContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2208);
/* harmony import */ var _utils_signature_owner__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10447);
/* harmony import */ var _components_google_ads_Buttons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71631);
/* harmony import */ var react_icons_hi2__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69274);
/* harmony import */ var components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(56475);









const CtaOne = (param)=>{
    let { heading1 , heading2 , heading3 , paragraph , paragraphStyling , buttonsStyling , buttonPrimaryText , buttonPrimaryUrl , buttonPrimaryIcon , buttonPrimaryBorderShadow , buttonPrimaryNewTab , buttonPrimaryBg , buttonSecondaryText , buttonSecondaryUrl , buttonSecondaryIcon , buttonSecondaryNewTab , signaturePopupOpen  } = param;
    var _context_globalData, _context_globalData_utmData;
    const context = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_components_AppContext__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z);
    const [signaturePopup, setSignaturePopup] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        open: false,
        mode: "register"
    });
    const [is1DollarTrialCampaignState, setIs1DollarTrialCampaignState] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const isSignaturePage = signaturePopupOpen;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        var _context_globalData, _context_globalData_utmData;
        setIs1DollarTrialCampaignState((0,_utils_signature_owner__WEBPACK_IMPORTED_MODULE_5__/* .is1DollarTrialCampaign */ .Og)({
            utm_campaign: context === null || context === void 0 ? void 0 : (_context_globalData = context.globalData) === null || _context_globalData === void 0 ? void 0 : (_context_globalData_utmData = _context_globalData.utmData) === null || _context_globalData_utmData === void 0 ? void 0 : _context_globalData_utmData.utm_campaign
        }));
    }, [
        context === null || context === void 0 ? void 0 : (_context_globalData = context.globalData) === null || _context_globalData === void 0 ? void 0 : (_context_globalData_utmData = _context_globalData.utmData) === null || _context_globalData_utmData === void 0 ? void 0 : _context_globalData_utmData.utm_campaign
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col gap-7 sm:gap-8",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_SignatureRegister__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                isPopupOpen: signaturePopup.open && isSignaturePage,
                mode: signaturePopup.mode,
                setIsPopupOpen: (value)=>setSignaturePopup((prev)=>({
                            ...prev,
                            open: value
                        })),
                setMode: (mode)=>setSignaturePopup((prev)=>({
                            ...prev,
                            mode: mode
                        }))
            }),
            heading1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                className: "font-bold text-4xl sm:text-5xl lg:text-6xl mxl:text-7xl",
                children: heading1
            }),
            heading2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "font-bold leading-[45px] sm:leading-[55px] lg:leading-tight text-[36px] sm:text-[48px] lg:text-5xl",
                children: heading2
            }),
            heading3 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: "font-bold text-2xl sm:text-3xl",
                children: heading3
            }),
            paragraph && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-lg sm:text-xl ".concat(paragraphStyling),
                children: paragraph
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mt-2 flex items-center flex-wrap gap-4 sm:gap-6 ".concat(buttonsStyling && buttonsStyling),
                children: [
                    buttonPrimaryText && (isSignaturePage ? is1DollarTrialCampaignState ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_google_ads_Buttons__WEBPACK_IMPORTED_MODULE_6__/* .Button1 */ .g, {
                        btnText: buttonPrimaryText,
                        bgColor: buttonPrimaryBg || "bg-violet-500",
                        textColor: "text-white",
                        border: "border border-violet-500 ",
                        showLoading: false,
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi2__WEBPACK_IMPORTED_MODULE_8__/* .HiArrowLongRight */ .P8b, {}),
                        borderShadow: buttonPrimaryBorderShadow !== null && buttonPrimaryBorderShadow !== void 0 ? buttonPrimaryBorderShadow : true,
                        px: "px-5"
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Buttons__WEBPACK_IMPORTED_MODULE_3__/* .ButtonPrimaryDiv */ .gf, {
                        buttonText: buttonPrimaryText,
                        onclick: ()=>setSignaturePopup((prev)=>({
                                    ...prev,
                                    open: true
                                })),
                        buttonUrl: buttonPrimaryUrl,
                        icon: buttonPrimaryIcon,
                        borderShadow: buttonPrimaryBorderShadow,
                        newTab: buttonPrimaryNewTab,
                        bgColor: buttonPrimaryBg
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_7__/* .CLMButtonPrimary */ .IS, {
                        buttonText: buttonPrimaryText,
                        buttonUrl: buttonPrimaryUrl,
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi2__WEBPACK_IMPORTED_MODULE_8__/* .HiArrowLongRight */ .P8b, {})
                    })),
                    buttonSecondaryText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_7__/* .CLMButtonSecondaryBorder */ .AL, {
                        buttonText: buttonSecondaryText,
                        buttonUrl: buttonSecondaryUrl
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CtaOne);


/***/ }),

/***/ 72023:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _constants_signature__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24599);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43138);
/* harmony import */ var _components_CTA_CtaOne__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59183);
/* harmony import */ var components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(56475);
/* harmony import */ var react_icons_go__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(66653);
/* harmony import */ var react_icons_bs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(63750);












const PdfTools = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full mt-12 md:mt-20",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Online PDF Tools - BoloForms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "Discover a suite of powerful PDF tools to help you manage your documents more efficiently. Merge, split, compress, and convert PDF files with ease. Try our online PDF tools today"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "geo.region",
                        content: "IN"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "geo.position",
                        content: "22.351115;78.667743"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "ICBM",
                        content: "22.351115, 78.667743"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "author",
                        content: "Boloforms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "publisher",
                        content: "BoloForms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "keywords",
                        content: "merge PDF, split PDF, rotate PDF, combine PDF, PDF converter, online PDF tools, PDF editor, PDF merge online, PDF split and merge, PDF rotate tool, PNG to PDF converter, JPEG to PDF converter, PDF to JPEG converter, PDF to PNG converter, PDF merge software, PDF split software, PDF rotate software, convert PDF to image, image to PDF converter, PDF conversion tool, PDF manipulation tools, free online PDF tools, edit PDF online, PDF merge and split, PDF compressor, PDF merger, PDF joiner, PDF cutter, PDF page rotation, batch PDF conversion, PDF processing tools"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: "https://www.bolosign.com/signature/pdf-tools/"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: "Online PDF Tools - BoloForms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:site",
                        content: "@boloforms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:url",
                        content: "https://www.bolosign.com/signature/pdf-tools/"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:title",
                        content: "Online PDF Tools - BoloForms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.bolosign.com/signature/pdf-tools/"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-[1280px] mx-auto px-4 md:px-10 rounded-xl relative flex flex-col gap-4 md:gap-10",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "max-w-3xl mx-auto text-center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CTA_CtaOne__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                heading1: "Online PDF Tools",
                                paragraph: "Free online PDF tools to merge, split, rotate, compress, convert, and many more. Manage your daily PDF tasks with our online PDF tools. \nEasily handle all your PDF documents without installing any software."
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6",
                                children: _constants_signature__WEBPACK_IMPORTED_MODULE_5__/* .signatureTools.map */ .kn.map((tool, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                        href: tool.url,
                                        className: "h-full bg-white border border-gray-300 rounded-xl transition duration-500 ease-in-out transform flex flex-col justify-between gap-6 group hover:shadow-lg hover:scale-105",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "h-full flex flex-col",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "bg-cream rounded-xl px-4 py-14 flex items-center justify-center",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                        src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_6__.BASE_ASSETS_URL, "/signature/tools/").concat(tool.image),
                                                        alt: tool.title,
                                                        width: 150,
                                                        height: 150,
                                                        className: "h-20 w-auto"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "flex-1 h-full px-6 py-8 flex flex-col justify-between items-start gap-4",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "flex-1 h-full",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                                                                    className: "text-xl font-bold flex items-center gap-2 flex-wrap text-gray-800 group-hover:text-blue-500 transition duration-300",
                                                                    children: [
                                                                        tool.title,
                                                                        " ",
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_go__WEBPACK_IMPORTED_MODULE_9__/* .GoArrowRight */ .e$1, {
                                                                            className: "text-2xl"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    className: "text-gray-700 text-base font-medium mt-1",
                                                                    children: tool.description
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "flex items-center",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_8__/* .CLMButtonPrimary */ .IS, {
                                                                buttonText: "Try It",
                                                                buttonUrl: tool.url,
                                                                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_bs__WEBPACK_IMPORTED_MODULE_10__/* .BsArrowRight */ .lzl, {})
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }, index))
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (PdfTools);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2013,3777,4599,9774,2888,179], function() { return __webpack_exec__(43068); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);